import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';

// A section whose header folds its content away; open to start with unless told otherwise
export default function Collapsible({ title, meta, defaultOpen = true, className = '', children }) {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();

  return (
    <section className={`collapsible ${open ? 'is-open' : 'is-closed'} ${className}`.trim()}>
      <button
        type="button"
        className="collapsible-head"
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={() => setOpen(!open)}
      >
        <h3>{title}</h3>
        {meta && <span className="collapsible-meta">{meta}</span>}
        <svg className="collapsible-chevron" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div id={bodyId} className="collapsible-body" hidden={!open}>
        {children}
      </div>
    </section>
  );
}

Collapsible.propTypes = {
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};
